<div class="container">
  <div class="row">
    <div class="col text-center">
      <div class="logo">
        <img
          src="assets/img/mdt-logo-blue.svg"
          alt=""
        >
      </div>
      <div class="description">
        <p>{{ 'generalpleasewaitinitializingyoursession' | translate }}...</p>
      </div>
      <div class="spinner">
        <img
          src="assets/img/spinner.svg"
          alt=""
        >
      </div>
    </div>
  </div>
</div>
